import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralSettingsService } from '../../services/general-settings/general-settings.service';
import { StageConfigService } from '../../services/stage-config/stage-config.service';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  private readonly generalSettingsService = inject(GeneralSettingsService);
  private readonly stageConfigService = inject(StageConfigService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(this.stageConfigService.config.mytcApiUrl)) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          'Accept-Language': this.generalSettingsService.getAcceptLanguageHeader(),
        },
      }),
    );
  }
}
